module.exports = __webpack_public_path__ + "f6e8d5a5256881c637adebc79ade4721.svg";